const APPLICATION_MENU = [
  {
    id: 'demographics',
    icon: 'building',
    text: 'Menu.Demographics',
    subMenuItems: [
      { text: 'Menu.InstitutionDetail', path: '/demographics/institution-detail', permission: 'CanViewInstitutions' },
      { text: 'Menu.Individuals', path: '/demographics/individuals', permission: 'CanViewIndividuals' },
      { text: 'Menu.ChangeRequests', path: '/demographics/change-requests', permission: 'CanViewChangeRequests' }
    ]
  },
  {
    id: 'communication',
    icon: 'conversation',
    text: 'Menu.Communication',
    subMenuItems: [
      { text: 'Menu.Messages', path: '/messages', permission: ['CanViewMessages', 'CanManageMessages', 'CanSendMessages'] }
    ]
  },
  {
    id: 'reports',
    icon: 'bxs-report',
    text: 'Menu.Reports',
    subMenuItems: [
      { text: 'Menu.Reports', path: '/report-submission-groups', permission: 'CanViewReports' },
      { text: 'Menu.Forecasts', path: '/forecast-report-submission-groups', permission: 'CanViewForecast' }
    ]
  },
  {
    id: 'documentation',
    icon: 'file',
    text: 'Menu.Documentation',
    subMenuItems: [
      { text: 'Menu.DocumentationViewer', path: '/documentation', permission: 'CanViewDocumentation' }
    ]
  },
  {
    id: 'administration',
    icon: 'cog',
    text: 'Menu.Administration',
    subMenuItems: [
      { text: 'Menu.UserManagement', path: '/users', permission: 'CanManageUsers' }
    ]
  }
]

export default APPLICATION_MENU



// WEBPACK FOOTER //
// ./src/report-app/menu-content.js